import { useState } from "react";
import { Link, useLocation, matchPath } from "react-router-dom";
import { useSelector } from "react-redux";
import { Menu, X } from "lucide-react";
import logo from "../../assets/Logo/logo.png";
import ProfileDropdown from "../core/Auth/ProfileDropDown";

const navItems = [
  { title: "Home", href: "/" },
  { title: "About Us", href: "https://www.thesafetymaster.com/about-us/" },
  { title: "Contact", href: "https://www.thesafetymaster.com/contact-us/" },
];

function Navbar() {
  const { user } = useSelector((state) => state.profile);
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const matchRoute = (route) => matchPath({ path: route }, location.pathname);

  return (
    <header className="sticky h-16 top-0 z-50 w-full bg-gradient-to-br from-slate-50 to-blue-50/30">
      <div className="mx-auto flex max-w-7xl h-16 items-center justify-between px-4">
        {/* Logo */}
        <Link to="/" className="flex items-center">
          <img src={logo} alt="Logo" className="h-12 w-auto" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex space-x-8">
          {navItems.map((item) => (
            <a
              key={item.title}
              href={item.href}
              className={`text-sm font-medium transition-colors duration-200 hover:text-blue-600 ${
                matchRoute(item.href) ? "text-blue-600" : "text-slate-600"
              }`}
            >
              {item.title}
            </a>
          ))}
        </nav>
      <div className="flex items-center">
        {/* Auth Buttons */}
        <div className="md:flex items-center space-x-4">
          {user ? (
            <ProfileDropdown />
          ) : (
            <div className="flex items-center gap-3">
              <Link to="/login">
                <button className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-800 transition-colors duration-200">
                  Log in
                </button>
              </Link>
              <Link to="/signup">
                <button className="px-6 py-2 text-sm font-medium bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 text-white rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105">
                  Sign up
                </button>
              </Link>
            </div>
          )}
        </div>

        

        {/* Mobile Menu Toggle */}
        <button 
          className="md:hidden p-2 rounded-lg hover:bg-slate-100 transition-colors duration-200" 
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-sm border-t border-white/20 shadow-lg">
          <div className="px-4 py-4 space-y-3">
            {navItems.map((item) => (
              <a
                key={item.title}
                href={item.href}
                className="block text-sm font-medium text-slate-600 hover:text-blue-600 py-2 transition-colors duration-200"
                onClick={() => setMenuOpen(false)}
              >
                {item.title}
              </a>
            ))}

            
          </div>
        </div>
      )}
    </header>
  );
}

export default Navbar;